import React, { useContext, useEffect } from "react"
import { withRouter } from "react-router"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"

import CustomerTable from "./CustomerTable"
import AuthContext from "../../context/authentication/authContext"
import TableContext from "../../context/table/tableContext"
import ReceiverContext from "../../context/receiver/ReceiverContext"
import { TextField } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  containerTabs: {
    margin: "auto",
    textAlign: "center",
  },
  tabs: {
    marginLeft: "30px",
    color: "#707070",
    "&:hover": {
      color: "#12b1ee !important",
      borderBottom: "solid 1px #12b1ee",
    },
  },
  title:{
    fontFamily:'Poppins',
    fontStyle:"normal",
    fontWeight:'400',
    fontSize:'32px',
    lineHeight:'20px',
    color:'#001070',
    marginBottom:'46px'
  },

  gridContainer: {
    width:"100%",

},

topButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "right",
  padding:"10px, 20px",
  gap: "10px",
  hover:"#001070",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
button:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#001070",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  '&:hover': {
    backgroundColor: '#001070',
    transform: 'translateY(-1px) !important'}

},
deleteButton:{
  display:"flex",
  flexDirection:"row",
  backgroundColor: "#DA291D",
  color: "#ffffff",
  float: "left",
  padding:"10px, 20px",
  gap: "10px",
  marginRight:"14px",
  '&:hover': {
    backgroundColor: '#DA291D',
    transform: 'translateY(-1px) !important'}

},

  importButton:{

    fontFamily:'Inter',
    fontStyle: 'normal',
    fontWeight:'500',
    fontSize:'14px',
    lineHeight: '20px',
    color:"#ffffff",
    backgroundColor: "#001070",
    textTransform: 'capitalize',
    padding: "10px, 20px",

  },
  searchButton:{
    width:"66px",
    height:"31px",

    marginLeft:"20px",
    borderRadius:"6px",
    padding:"10px, 20px",
    borderColor:"#E8E9EA",
    backgroundColor: "#DA291D",
    cursor: "pointer",
    color: "#ffffff",
    float: "right",
    fontSize:"14px",

  },
  searchField:{
    border: "1px solid #E8E9EA",
    padding: "15px 0px 15px 15px",
    width:"301px",
    height:"31px",
    marginLeft:"40px",
    marginBottom:"30px",
    marginTop:"20px",
    backgroundColor: "#ffffff",
    borderColor:"#E8E9EA",
    borderRadius:"6px",
    fontFamily:"Poppins",
    fontSize:"16px",
  },
}))

const CustomersTables = (props) => {
  const authContext = useContext(AuthContext)
  const {  authenticatedUser } = authContext //closeSession,
  const isProvider = props.type === 2
  const classes = useStyles()
  const {
    error,
    getReceiver ,
    deleteReceiver,
    currentType,
    showEditReceiver,
    totalPages,
    filterCriteria,
    currentPage,
    maxPerPage,
    setCurrentPage,
    setMaxPerPage,
    setFilterCriteria
  } =  useContext(ReceiverContext)

  function _search(event){
       const s = document.getElementById('rut-search')
       const customers = JSON.parse(localStorage.getItem('customers'))
       setFilterCriteria(s.value)
       getReceiver(customers[0].id,currentType,s.value,currentPage,maxPerPage)
  }

  const columnsReceivers = [
    { name: "RUT" },
    { name: "RAZÓN SOCIAL" },
    {  name: "GIRO" },
    { name: "DIRECCIÓN" },
    { name: "COMUNA" },
    { name: "ACCIONES" }
  ]

  useEffect(() => {
    authenticatedUser()
  //  getTransactionsData()
  }, [])
  return (
  <div>
    <div className={classes.title}>
        {!isProvider  && <>Clientes</>}
        {isProvider  && <>Proveedores</>}
    </div>
      <Grid container spacing={12} style={{alignItems:"center"}}>
        <div>
          <TextField type="search" id="rut-search" name="q"  placeholder="Nombre o Rut" variant="outlined"
         onChange={_search}
         style={{
          width:"301px",
          backgroundColor: "#ffffff",
          borderColor:"#E8E9EA",
          borderRadius:"6px",
          fontSize:"16px",}}
           ></TextField>
         </div>
         <div>
          <button  className={classes.searchButton}
            onClick={_search} >Buscar</button>
        </div>
      </Grid>
      <Grid item xs={12}>
        <CustomerTable
          columns={columnsReceivers}
          maxPerPage={maxPerPage}
          setMaxPerPage={setMaxPerPage}

        />
      </Grid>
      
    </div>
  )
}

export default withRouter(CustomersTables)
